import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Trilha de navegação ("Planos › Parâmetros de Plano › Plano CD II"). O último passo é a página
 * atual, em destaque e marcado com `aria-current="page"`. Os passos ainda não são links: as
 * rotas da trilha não foram definidas.
 *
 * @example
 * <app-trilha-navegacao [passos]="['Planos', 'Parâmetros de Plano']" />
 */
@Component({
  selector: 'app-trilha-navegacao',
  standalone: true,
  imports: [],
  templateUrl: './trilha-navegacao.component.html',
  styleUrl: './trilha-navegacao.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrilhaNavegacaoComponent {
  readonly passos = input.required<readonly string[]>();
}
